import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-decsis-cloud',
  templateUrl: './decsis-cloud.component.html',
  styleUrls: ['./decsis-cloud.component.css']
})
export class DecsisCloudComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
